import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TranslatorContext } from "../../../context/Translator";
import { Row, Col, Card, Button, Badge, Table, Spinner } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";
// Icons update kiye gaye hain niche
import { FiArrowLeft, FiUser, FiMail, FiPhone, FiMapPin, FiCalendar, FiPackage, FiShoppingCart, FiCheckCircle, FiXCircle } from "react-icons/fi";
import { FaPrint, FaMotorcycle } from "react-icons/fa";
import Swal from 'sweetalert2';

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

// Yahan icon change kar diya gaya hai
const STATUS_STEPS = [
    { value: 'pending', label: 'Pending', icon: <FiShoppingCart /> },
    { value: 'processing', label: 'Processing', icon: <FiPackage /> },
    { value: 'on_the_way', label: 'On The Way', icon: <FaMotorcycle /> },
    { value: 'delivered', label: 'Delivered', icon: <FiCheckCircle /> },
    { value: 'cancelled', label: 'Cancelled', icon: <FiXCircle /> }
];

export default function OrderShowPage() {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const { id } = useParams();
    const AuthToken = localStorage.getItem("authToken");

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOrderDetails();
    }, [id]);

    const fetchOrderDetails = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/orders/${id}`,
                { headers: { Authorization: `Bearer ${AuthToken}` } }
            );
            setOrder(response.data.order);
        } catch (err) {
            console.error('Error fetching order details:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch order details',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            setTimeout(() => navigate('/orders'), 2000);
        } finally {
            setLoading(false);
        }
    };

    const handlePrintInvoice = () => {
        window.open(`${process.env.REACT_APP_URL}/invoice-print/${id}`, "_blank");
    };

    if (loading) {
        return (
            <PageLayout>
                <div className="text-center p-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading order details...</p>
                </div>
            </PageLayout>
        );
    }

    if (!order) return null;

    const currentStatusIndex = STATUS_STEPS.findIndex(s => s.value === order.status);

    // Calculate order summary values
    const subtotal = order.products?.reduce((sum, product) => sum + parseFloat(product.total), 0) || 0;
    const shippingCost = parseFloat(order.shipping_cost) || 0;
    const discount = parseFloat(order.discount) || 0;
    const tax = parseFloat(order.tax) || 0;
    const grandTotal = parseFloat(order.total_amount) || 0;

    return (
        <PageLayout>

            <div className="order-show-page">
                <div className="sticky-header p-3 bg-white shadow-sm mb-4 rounded">
                    <Row className="align-items-center">
                        <Col md={8}>
                            <h2 className="mb-0 fw-bold">
                                <FiShoppingCart className="me-2 text-primary" />
                                Order Details
                            </h2>
                            <p className="text-muted mt-1 mb-0">
                                Order Number: <strong className="text-primary">{order.order_number}</strong>
                            </p>
                        </Col>
                        <Col md={4} className="d-flex justify-content-end gap-2">
                            <Button variant="secondary" onClick={() => navigate('/orders')}>
                                <FiArrowLeft className="me-1" /> Back
                            </Button>
                            <Button variant="primary" onClick={handlePrintInvoice} className="gap-2 d-flex align-items-center">
                                <FaPrint /> Print Invoice
                            </Button>
                        </Col>
                    </Row>
                </div>

                {order.status !== 'cancelled' ? (
                    <Card className="shadow-sm mb-4 border-0">
                        <Card.Body className="py-4">
                            <div className="stepper-wrapper">
                                {STATUS_STEPS.map((step, index) => {
                                    const isCompleted = index <= currentStatusIndex;
                                    const isActive = index === currentStatusIndex;
                                    return (
                                        <div key={index} className={`stepper-item ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}>
                                            <div className="step-counter">{step.icon}</div>
                                            <div className="step-name">{step.label}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Card.Body>
                    </Card>
                ) : (
                    <Card className="shadow-sm mb-4 border-0 bg-light text-center py-3">
                        <Badge bg="danger" className="px-4 py-2 fs-6">Order Cancelled</Badge>
                    </Card>
                )}

                <Row>
                    <Col md={6} className="mb-4">
                        <Card className="shadow-sm h-100">
                            <Card.Header className="bg-white border-bottom">
                                <h5 className="mb-0"><FiUser className="me-2 text-primary" /> Customer Info</h5>
                            </Card.Header>
                            <Card.Body>
                                <p><strong>Name:</strong> {order.name}</p>
                                <p><strong>Email:</strong> {order.email}</p>
                                <p><strong>Phone:</strong> {order.phone}</p>
                                <p><strong>Address:</strong> {order.address}, {order.city}</p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} className="mb-4">
                        <Card className="shadow-sm h-100">
                            <Card.Header className="bg-white border-bottom">
                                <h5 className="mb-0"><FiCalendar className="me-2 text-primary" /> Summary</h5>
                            </Card.Header>
                            <Card.Body>
                                <p><strong>Date:</strong> {formatDate(order.order_date)}</p>
                                <p><strong>Total:</strong> <span className="text-success fw-bold">{parseFloat(order.total_amount)}</span></p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col md={8} className="mb-4">
                        <Card className="shadow-sm mb-4">
                            <Card.Body className="p-0">
                                <Table hover className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Product</th>
                                            <th className="text-center">Qty</th>
                                            <th className="text-end">Price</th>
                                            <th className="text-end">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.products?.map((p, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{p.name}</td>
                                                <td className="text-center">{p.qty}</td>
                                                <td className="text-end">{parseFloat(p.price)}</td>
                                                <td className="text-end fw-bold">{parseFloat(p.total)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4">
                        <Card className="shadow-sm">
                            <Card.Header className="bg-white border-bottom">
                                <h5 className="mb-0">Order Summary</h5>
                            </Card.Header>
                            <Card.Body>
                                <div className="d-flex justify-content-between mb-2">
                                    <span>Subtotal:</span>
                                    <span>{subtotal}</span>
                                </div>
                                {shippingCost > 0 && (
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Shipping:</span>
                                        <span>{shippingCost}</span>
                                    </div>
                                )}
                                {discount > 0 && (
                                    <div className="d-flex justify-content-between mb-2 text-danger">
                                        <span>Discount:</span>
                                        <span>- {discount}</span>
                                    </div>
                                )}
                                {tax > 0 && (
                                    <div className="d-flex justify-content-between mb-2">
                                        <span>Tax:</span>
                                        <span>{tax}</span>
                                    </div>
                                )}
                                <hr />
                                <div className="d-flex justify-content-between mb-0 fw-bold">
                                    <span>Grand Total:</span>
                                    <span className="text-success">{grandTotal}</span>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </PageLayout>
    );
}